import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ColumnAlignment } from '@mews/b2b-ui';
import { WithScope } from '@mews-commander/types';
import EntityTable from '../../../entityManagement/components/EntityTable';
import { getCategoriesOrdering } from '../../selectors/categories';
import {
    CategoryShortcut,
    CategoryCapacity,
    CategoryType,
    CategoriesEditLink,
    CategoriesButtonActions,
} from './tableElements';

const mapping = [
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.Category} />,
        render: (id: string, { scope }: WithScope) => <CategoriesEditLink scope={scope} id={id} />,
        columnWidth: '20%',
    },
    {
        valueKey: 'shortcut',
        title: <LocalizedText textKey={TextKey.ShortName} />,
        render: (id: string, { scope }: WithScope) => <CategoryShortcut id={id} scope={scope} />,
        columnWidth: '20%',
    },
    {
        valueKey: 'resourceCategoryType',
        title: <LocalizedText textKey={TextKey.Type} />,
        render: (id: string, { scope }: WithScope) => <CategoryType id={id} scope={scope} />,
        columnWidth: '20%',
    },
    {
        valueKey: 'capacity',
        title: <LocalizedText textKey={TextKey.Capacity} />,
        render: (id: string, { scope }: WithScope) => <CategoryCapacity id={id} scope={scope} />,
        columnWidth: '20%',
    },
    {
        valueKey: '',
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        render: (id: string, { scope }: WithScope) => <CategoriesButtonActions scope={scope} id={id} />,
        columnWidth: '20%',
        columnAlignment: ColumnAlignment.Right,
    },
];

const CategoriesTable = EntityTable({ mapping });

export default connect(
    createStructuredSelector({
        source: getCategoriesOrdering,
    })
)(CategoriesTable);
